"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCancelPaymentPath = exports.cancelPayment = void 0;
const axios_client_1 = require("@invivodf/axios-client");
const cancelPayment = (client) => async ({ checkoutId }) => {
    return (0, axios_client_1.httpResultWrapper)(() => client.post((0, exports.getCancelPaymentPath)(checkoutId)));
};
exports.cancelPayment = cancelPayment;
const getCancelPaymentPath = (checkoutId) => `/v2/bff/appro/checkouts/${checkoutId}/cancelPayment`;
exports.getCancelPaymentPath = getCancelPaymentPath;
